import React, { useRef } from 'react';
import { Navbar, NavbarBrand, NavItem, NavLink, Nav } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { useIsAuthenticated } from "@azure/msal-react";
import { SignIn } from './SignIn';
import { SignOut } from './SignOut';
import { useState, useEffect } from 'react';
import HomeImage from '../img/Home.svg';
import { AuthenticatedTemplate } from "@azure/msal-react";
import logo from "../img/Logo.png";
import { useTheme } from './ThemeContext';
import { useMsal } from "@azure/msal-react";
import { GetAccessToken } from "../index";
import { ProfileData } from "./ProfileData";

export function NavMenu() {
    const { theme, toggleTheme } = useTheme();
    const isAuthenticated = useIsAuthenticated();
    const { instance, accounts } = useMsal();
    const [agency, setAgency ] = useState([]);
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef();
    const [permissions, setPermissions] = useState([]);
    const StatsPortalUrl = () => {
        window.location.href = 'https://statistics.reinz.co.nz/main/landing'
    }
    //Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
  
   
    if (permissions === "NoAccess") {
        return null; // Hide the entire navbar if the user has no access
        console.log("Access Status:", permissions);
    }
    else {
        console.log("Access Status:", permissions);
    }

    
    if (agency === null) {
        return null;
        console.log("Agency Status:", agency);
    }
    else { console.log("Agency Status:", agency) }

    return (
        <header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow">
                <div id="NavMenuDiv">
                    <NavbarBrand tag={Link} to="https://reinz.co.nz">
                        <img src={HomeImage} width={60} height={60} style={{ paddingLeft: "-100px" }} />
                        <label id="LabelId">Returns Portal</label>
                    </NavbarBrand>
                    <button className="btnClass" onClick={StatsPortalUrl}>
                        <i className="bi bi-arrow-left-square" style={{ marginRight: "8px", height: "1px" }}></i>
                        <label id="LabelId">Back to Stats Portal</label>
                    </button>
                </div>  
                
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems:'center'}}>
                    {/*Theme Switcher*/}
                    <label className="switcher">
                        <input
                            type="checkbox"
                            name="theme-switcher"
                            checked={theme === 'light'} // Check if the theme is 'light'
                            onChange={toggleTheme} // Toggle the theme when clicked
                        />
                        <div>
                            <i className="fas fa-sun"></i> {/* Sun Icon */}
                            <i className="fas fa-arrow-right arrow"></i> {/* Arrow Icon */}
                            <i className="fas fa-moon"></i> {/* Moon Icon */}
                        </div>
                    </label>
                    {/*Dropdown*/}
                    {isAuthenticated &&
                        <div style={{ position: 'relative' }} ref={dropdownRef}>
                            <button onClick={() => setOpen(!open)} className="flex items-center gap-2 px-4 py-2 bg-purple-700 text-white text-sm rounded hover:bg-purple-800 focus:outline-none"
                                style={{ backgroundColor: "#563abe", color: "#ffffff", fontSize: "1.0rem", fontWeight: "600", marginLeft: "1vh" }}>
                                Help and Guides <i className="fa fa-question-circle"></i></button>
                            {open &&
                                <div style={{
                                    position: 'absolute',
                                    top: '100%',
                                    right: 0,
                                    marginTop: '8px',
                                    backgroundColor: 'white',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                    borderRadius: '6px',
                                    zIndex: 999,
                                    width: '215px',
                                }}>
                                    <a href="/REINZ User Guide.pdf" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'nowrap', padding: '8px 16px', display: 'block', color: '#563abe', fontWeight: "500" }}>Download User Guide</a>
                                    <a href="/REINZ Statistics User Agreement.pdf" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'nowrap', padding: '8px 16px', display: 'block', color: '#563abe', fontWeight: "500" }}>Download User Agreement</a>
                                </div>

                            }
                        </div>
                    }
                    {/*Authentication*/}
                    {isAuthenticated ?
                        <div>
                            <NavLink tag={Link} to="/"><SignOut /></NavLink>
                            <ProfileData onPermissionsFetched={setPermissions} onAgencyFetched={setAgency} />
                        </div> :
                        <div>
                            <NavLink tag={Link} to="/"><SignIn /></NavLink>
                        </div>
                    }
                </div>
                
            </Navbar>

            <div style={{ backgroundColor: "black", flexDirection: "row", display: "flex" }}>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom mb-3 barStyle">
                    <div className="ReinzImageDiv">
                        <NavbarBrand tag={Link} id="reinzimage" to="/">
                            <img src={logo} width={220} height={58} style={{ marginLeft: "0.5em" }}></img>
                        </NavbarBrand>
                    </div>
                    {permissions === "StatsAdmin" ? (
                        <AuthenticatedTemplate>
                            <Nav className='ms-auto' navbar>
                                <NavItem>
                                    <NavLink tag={Link} style={{ color: "white", marginRight: "3em", fontWeight: "700" }} to="/GetReturnsListResidentialandRural">Rural & Residential Returns</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} style={{ color: "white", marginRight: "3em", fontWeight: "700" }} to="/GetReturnsListNil">Nil Returns</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} style={{ color: "white", marginRight: "3em", fontWeight: "700" }} to="/AddResidentialReturn">Add a Residential Return</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} style={{ color: "white", marginRight: "3em", fontWeight: "700" }} to="/AddRuralReturn">Add a Rural Return</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} style={{ color: "white", marginRight: "3em", fontWeight: "700" }} to="/AddNilReturn">Add a Nil Return</NavLink>
                                </NavItem>
                                {agency === "REINZ" &&
                                    <NavItem>
                                        <NavLink tag={Link} style={{ color: "white", marginRight: "3em", fontWeight: "700" }} to="/AdminReports">Admin Reports</NavLink>
                                    </NavItem>
                                }
                            </Nav>
                        </AuthenticatedTemplate> ): null}
                </Navbar>
            </div>
        </header>
    );
}
